import { ref, computed } from 'vue';
import { injectLocal, provideLocal } from '@vueuse/core';
import { useBagContext } from '~/modules/add-to-bag/composables/useBagContext';
import { PRODUCT_QUANTITY_REPOSITORY } from '../constants/providers';
import { useProduct } from './useProduct';

export const useQuantity = () => {
  return injectLocal(PRODUCT_QUANTITY_REPOSITORY);
};

export const useQuantityProvide = (initValue?: number) => {
  const { query } = useRoute();
  const { productData } = useProduct();
  const { isUpdateBagEnabled } = useBagContext();

  const initialQuantity = initValue ?? (isUpdateBagEnabled && query?.Quantity ? Number.parseInt(query?.Quantity, 10) : 1);

  /**
   * * Minimum quanitity value
   */
  const minQuantity = 1;
  /**
   * * Maximum quanity value
   */
  const maxQuantity = productData?.detail?.maxQuantity || 6;

  /**
   * * Inner quantity value
   *
   * Initial value based on
   */
  const quantityValue = ref(initialQuantity);

  const quantity = computed({
    get() {
      return quantityValue.value;
    },
    set(value) {
      quantityValue.value = Math.min(Math.max(value, minQuantity), maxQuantity);
    },
  });

  provideLocal(PRODUCT_QUANTITY_REPOSITORY, {
    quantity,
    minQuantity,
    maxQuantity,
  });
};
